import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  createFilterOptions,
  Paper,
  CircularProgress,
  Autocomplete,
  TextField,
  Typography,
  Chip,
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Clear } from "@mui/icons-material";
import { color } from "../../../StyleData/Config";
import { axiosPrivate } from "../../../axios/axios";
import { masterAPI } from "../dataConfig";
import { useSelector } from "react-redux";
import ErrorProps from "../../../Component/Errorprops";
import { toast } from "react-toastify";

const WorkFlowModal = ({ mode, handleCloseClick, editData }) => {
  const siteInfoDetail = useSelector((state) => state.auth.loginInfo);
  const [loading, setLoading] = useState(false);
  const [roles, setRoles] = useState([]);
  const [persons, setPersons] = useState([]);
  const [workflowTypes, setWorkflowTypes] = useState([]);
  const [workflowLevels, setWorkflowLevels] = useState([]);
  const [workTypes, setWorkTypes] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [loadingRoles, setLoadingRoles] = useState(false);
  const [loadingPersons, setLoadingPersons] = useState(false);
  const [loadingWorkflowTypes, setLoadingWorkflowTypes] = useState(false);
  const [loadingWorkflowLevels, setLoadingWorkflowLevels] = useState(false);
  const [loadingWorkTypes, setLoadingWorkTypes] = useState(false);
  const setFieldValueRef = useRef(null);

  const defaultFilterOptions = createFilterOptions();
  const filterOptions = (options, state) => {
    return defaultFilterOptions(options, state);
  };
  const CustomPaper = (props) => {
    return <Paper elevation={8} {...props} />;
  };

  useEffect(() => {
    getRoles();
    getWorkflowTypes();
    getWorkflowLevels();
    getWorkTypes();
    if (mode === "Edit" && editData.roleId) {
      setSelectedRole(editData.roleId);
      getPersonsByRole(editData.roleId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getRoles = async () => {
    setLoadingRoles(true);
    const link = masterAPI["selectList"].getRoles;
    await axiosPrivate
      .get(`${link}`)
      .then((res) => {
        const rolesData = Array.isArray(res.data)
          ? res.data
          : res.data.result || [];
        setRoles(rolesData);
        setLoadingRoles(false);
      })
      .catch((e) => {
        setRoles([]);
        setLoadingRoles(false);
      });
  };

  const getPersonsByRole = async (roleId) => {
    if (!roleId) {
      setPersons([]);
      if (setFieldValueRef.current) setFieldValueRef.current("personList", []);
      return;
    }
    setLoadingPersons(true);
    const link = masterAPI["selectList"].getUsersByRole;
    await axiosPrivate
      .get(`${link}/${roleId}`)
      .then((res) => {
        const personsData = Array.isArray(res.data)
          ? res.data
          : res.data.result || [];
        setPersons(personsData);
        if (setFieldValueRef.current)
          setFieldValueRef.current("personList", personsData);
        setLoadingPersons(false);
      })
      .catch((e) => {
        setPersons([]);
        if (setFieldValueRef.current)
          setFieldValueRef.current("personList", []);
        setLoadingPersons(false);
      });
  };

  const getWorkflowTypes = async () => {
    setLoadingWorkflowTypes(true);
    const link = masterAPI["selectList"].workflowByTypes;
    await axiosPrivate
      .get(`${link}`)
      .then((res) => {
        const typesData = Array.isArray(res.data)
          ? res.data
          : res.data.result || [];
        setWorkflowTypes(typesData);
        setLoadingWorkflowTypes(false);
      })
      .catch((e) => {
        setWorkflowTypes([]);
        setLoadingWorkflowTypes(false);
      });
  };

  const getWorkflowLevels = async () => {
    setLoadingWorkflowLevels(true);
    const link = masterAPI["selectList"].workflowLevels;
    await axiosPrivate
      .get(`${link}`)
      .then((res) => {
        const levelsData = Array.isArray(res.data)
          ? res.data
          : res.data.result || [];
        setWorkflowLevels(levelsData);
        setLoadingWorkflowLevels(false);
      })
      .catch((e) => {
        setWorkflowLevels([]);
        setLoadingWorkflowLevels(false);
      });
  };

  const getWorkTypes = async () => {
    setLoadingWorkTypes(true);
    const link = masterAPI["selectList"].workordertype;
    await axiosPrivate
      .get(`${link}`)
      .then((res) => {
        const typesData = Array.isArray(res.data)
          ? res.data
          : res.data.result || [];
        setWorkTypes(typesData);
        setLoadingWorkTypes(false);
      })
      .catch((e) => {
        setWorkTypes([]);
        setLoadingWorkTypes(false);
      });
  };

  const initialValue = {
    name: mode === "Edit" ? editData.name : "",
    description: mode === "Edit" ? editData.description : "",
    roleId: mode === "Edit" ? editData.roleId : "",
    workFlowFor:
      mode === "Edit" ? editData.workFlowFor || editData.workflowFor : "",
    workFlowLevel: mode === "Edit" ? editData.workFlowLevel : "",
    workTypeIdList:
      mode === "Edit"
        ? editData.workTypeIdList ||
          (editData.workTypeId ? [editData.workTypeId] : [])
        : [],
    personList: [],
  };

  const onSubmit = async (value) => {
    const payload = {
      ...value,
      workflowFor: value.workFlowFor,
      workTypeIdList: value.workTypeIdList,
    };
    delete payload.workFlowFor;
    // Remove old workTypeId if present
    delete payload.workTypeId;
    delete payload.personList;

    setLoading(true);
    const createLink = masterAPI["workFlow"].create;
    const updateLink = masterAPI["workFlow"].update;
    if (mode === "Create") {
      await axiosPrivate
        .post(`${createLink}`, payload)
        .then((res) => {
          toast.success("WorkFlow created successfully");
          setLoading(false);
          handleCloseClick();
        })
        .catch((e) => {
          setLoading(false);
          toast.error(
            e.response?.data?.failureMessage || "Error creating workflow",
          );
        });
    } else {
      const updateWF = {
        id: editData.id,
        ...payload,
      };
      await axiosPrivate
        .put(`${updateLink}`, updateWF)
        .then((res) => {
          toast.success("WorkFlow updated successfully");
          setLoading(false);
          handleCloseClick();
        })
        .catch((e) => {
          setLoading(false);
          toast.error(
            e.response?.data?.failureMessage || "Error updating workflow",
          );
        });
    }
  };

  const handleCancel = () => {
    handleCloseClick();
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    description: Yup.string().required("Description is required"),
    roleId: Yup.string().required("Role is required"),
    workFlowFor: Yup.string().required("WorkFlow Type is required"),
    workFlowLevel: Yup.string().required("WorkFlow Level is required"),
    workTypeIdList: Yup.array().min(1, "At least one Work Type is required"),
    personList: Yup.array().min(1, "Users in Selected Role is required"),
  });

  return (
    <Box sx={{ p: color.masterPageDialogPadding }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            color: color.masterDialogTitleColor,
            fontSize: color.masterDialogFontSize,
          }}
        >
          {mode === "Edit" ? editData.name : "New Work Flow"}
        </Typography>
        <IconButton onClick={handleCancel}>
          <Clear />
        </IconButton>
      </Box>
      <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)", mb: "15px" }} />
      <Formik
        initialValues={initialValue}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ setFieldValue, values, errors, touched, setFieldTouched }) => {
          setFieldValueRef.current = setFieldValue;
          return (
            <Form>
              <Grid container spacing={"1rem"}>
                <Grid item xs={12} md={6}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Name
                  </Typography>
                  <Field
                    as={TextField}
                    size={"small"}
                    type="text"
                    name="name"
                    placeholder="Enter Name"
                    fullWidth
                    sx={{
                      ".MuiInputBase-input": {
                        "&::placeholder": {
                          opacity: 1,
                          color: color.placeholderColor,
                          fontSize: "13px",
                        },
                      },
                    }}
                  />
                  <ErrorMessage name="name">
                    {(error) => <ErrorProps>{error}</ErrorProps>}
                  </ErrorMessage>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    WorkFlow Type
                  </Typography>
                  <Autocomplete
                    value={
                      workflowTypes.find(
                        (wt) => wt.value === values.workFlowFor,
                      ) || null
                    }
                    fullWidth
                    filterOptions={filterOptions}
                    loading={loadingWorkflowTypes}
                    options={workflowTypes}
                    PaperComponent={CustomPaper}
                    getOptionLabel={(option) => option.text || option}
                    onChange={(event, value) => {
                      if (value !== null) {
                        setFieldValue("workFlowFor", value.value);
                      } else {
                        setFieldValue("workFlowFor", "");
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name="workFlowFor"
                        placeholder="Select WorkFlow Type"
                        variant="outlined"
                        size="small"
                        fullWidth
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {loadingWorkflowTypes ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        }}
                      />
                    )}
                  />
                  <ErrorMessage name="workFlowFor">
                    {(error) => <ErrorProps>{error}</ErrorProps>}
                  </ErrorMessage>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    WorkFlow Level
                  </Typography>
                  <Autocomplete
                    value={
                      workflowLevels.find(
                        (wl) => wl.value === values.workFlowLevel,
                      ) || null
                    }
                    fullWidth
                    filterOptions={filterOptions}
                    loading={loadingWorkflowLevels}
                    options={workflowLevels}
                    PaperComponent={CustomPaper}
                    getOptionLabel={(option) => option.text || option}
                    onChange={(event, value) => {
                      if (value !== null) {
                        setFieldValue("workFlowLevel", value.value);
                      } else {
                        setFieldValue("workFlowLevel", "");
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name="workFlowLevel"
                        placeholder="Select WorkFlow Level"
                        variant="outlined"
                        size="small"
                        fullWidth
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {loadingWorkflowLevels ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        }}
                      />
                    )}
                  />
                  <ErrorMessage name="workFlowLevel">
                    {(error) => <ErrorProps>{error}</ErrorProps>}
                  </ErrorMessage>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Role
                  </Typography>
                  <Autocomplete
                    value={roles.find((r) => r.value === values.roleId) || null}
                    fullWidth
                    filterOptions={filterOptions}
                    loading={loadingRoles}
                    options={roles}
                    PaperComponent={CustomPaper}
                    getOptionLabel={(option) => option.text || option}
                    onChange={(event, value) => {
                      if (value !== null) {
                        setFieldValue("roleId", value.value);
                        setSelectedRole(value.value);
                        getPersonsByRole(value.value).then(() => {
                          setFieldTouched("personList", true, false);
                        });
                      } else {
                        setFieldValue("roleId", "");
                        setSelectedRole(null);
                        setPersons([]);
                        setFieldValue("personList", []);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name="roleId"
                        placeholder="Select Role"
                        variant="outlined"
                        size="small"
                        fullWidth
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {loadingRoles ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        }}
                      />
                    )}
                  />
                  <ErrorMessage name="roleId">
                    {(error) => <ErrorProps>{error}</ErrorProps>}
                  </ErrorMessage>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Work Type
                  </Typography>
                  <Autocomplete
                    multiple
                    value={workTypes.filter((wt) =>
                      values.workTypeIdList.includes(wt.value),
                    )}
                    fullWidth
                    filterOptions={filterOptions}
                    loading={loadingWorkTypes}
                    options={workTypes}
                    PaperComponent={CustomPaper}
                    getOptionLabel={(option) => option.text || option}
                    onChange={(event, value) => {
                      setFieldValue(
                        "workTypeIdList",
                        value.map((v) => v.value),
                      );
                    }}
                    renderTags={(selected, getTagProps) =>
                      selected.map((option, index) => (
                        <Chip
                          label={option.text}
                          {...getTagProps({ index })}
                          size="small"
                          variant="outlined"
                          sx={{ backgroundColor: "#e3f2fd" }}
                        />
                      ))
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name="workTypeIdList"
                        placeholder="Select Work Type(s)"
                        variant="outlined"
                        size="small"
                        fullWidth
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <React.Fragment>
                              {loadingWorkTypes ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          ),
                        }}
                      />
                    )}
                  />
                  <ErrorMessage name="workTypeIdList">
                    {(error) => <ErrorProps>{error}</ErrorProps>}
                  </ErrorMessage>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Users in Selected Role
                  </Typography>
                  <Box
                    sx={{
                      border:
                        errors.personList && touched.personList
                          ? "1px solid #d32f2f"
                          : "1px solid #c4c4c4",
                      borderRadius: "4px",
                      padding: "8px 12px",
                      minHeight: "40px",
                      backgroundColor: selectedRole ? "#fff" : "#f5f5f5",
                      display: "flex",
                      alignItems: "center",
                      flexWrap: "wrap",
                      gap: "8px",
                    }}
                  >
                    {loadingPersons ? (
                      <CircularProgress size={20} />
                    ) : !selectedRole ? (
                      <Typography sx={{ color: "#999", fontSize: "13px" }}>
                        Select a role to view users
                      </Typography>
                    ) : persons.length === 0 ? (
                      <Typography sx={{ color: "#999", fontSize: "13px" }}>
                        No users found for this role
                      </Typography>
                    ) : (
                      persons.map((person, index) => (
                        <Chip
                          key={index}
                          label={person.text}
                          size="small"
                          variant="outlined"
                          sx={{ backgroundColor: "#e3f2fd" }}
                        />
                      ))
                    )}
                  </Box>
                  <ErrorMessage name="personList">
                    {(error) => <ErrorProps>{error}</ErrorProps>}
                  </ErrorMessage>
                </Grid>

                <Grid item xs={12}>
                  <Typography
                    sx={{
                      fontWeight: color.labelFontWeight,
                      mb: color.labelmb,
                      fontSize: color.labelFont,
                      color: color.labelColor,
                    }}
                  >
                    Description
                  </Typography>
                  <Field
                    as={TextField}
                    size={"small"}
                    type="text"
                    name="description"
                    placeholder="Enter Description"
                    fullWidth
                    multiline
                    rows={3}
                    sx={{
                      ".MuiInputBase-input": {
                        "&::placeholder": {
                          opacity: 1,
                          color: color.placeholderColor,
                          fontSize: "13px",
                        },
                      },
                    }}
                  />
                  <ErrorMessage name="description">
                    {(error) => <ErrorProps>{error}</ErrorProps>}
                  </ErrorMessage>
                </Grid>

                <Grid
                  container
                  item
                  xs={12}
                  justifyContent={"flex-end"}
                  gap="1rem"
                >
                  <Button
                    onClick={handleCancel}
                    variant="contained"
                    sx={{
                      backgroundColor: color.TableCancelButton,
                      textTransform: "none",
                      color: color.CancelTextColor,
                      ":hover": {
                        backgroundColor: color.TableCancelButton,
                        textTransform: "none",
                        color: color.CancelTextColor,
                      },
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    type={"submit"}
                    variant="contained"
                    disabled={loading}
                    sx={{
                      textTransform: "none",
                      backgroundColor: loading
                        ? "default"
                        : color.TableButtonColor,
                      "&:hover": {
                        backgroundColor: loading
                          ? "default"
                          : color.buttonDisable,
                      },
                    }}
                  >
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </Form>
          );
        }}
      </Formik>
    </Box>
  );
};

export default WorkFlowModal;
